<template>
  <div class="pa-4">
    <v-row>
      <v-col cols="12">
        <span class="text-h5 text-uppercase font-weight-bold text_color--text">
          {{ adminDashboardModule.dashboard }}
        </span>
      </v-col>

      <v-col cols="12">
        <v-row>
          <v-col
            v-for="(value, key, index) in dashboardStatistics"
            :key="index"
          >
            <v-card
              elevation="0"
              min-width="10vw"
              class="card-box-shadow h-100"
            >
              <v-card-text>
                <v-row class="d-flex align-content-space-between">
                  <v-col cols="12">
                    <h6 class="text-subtitle-2 text-capitalize mb-2" v-if="key">
                      {{ key.replace(/_/g, " ") }}
                    </h6>
                  </v-col>
                  <v-col cols="12">
                    <h2 color="black">{{ value }}</h2>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-col>
      <!-- <v-col cols="12" class="pb-2">
        <span class="text-body-1 font-weight-bold"> Subscription Details </span>
      </v-col> -->
      <v-col
        cols="12"
        md="6"
        lg="3"
        v-if="subscriptionInfo && Object.keys(subscriptionInfo).length > 0"
      >
        <span class="text-body-1 font-weight-bold"> Subscription Details </span>
        <v-card
          class="pa-0 h-100"
          elevation="0"
          min-height="300px"
          max-height="43.5vh"
        >
          <v-card-title class="pa-0">
            <v-tabs
              v-model="subSubscriptionTab"
              :show-arrows="true"
              centered
              grow
            >
              <v-tab>
                <h6 class="text-subtitle-2 text-capitalize">Active</h6>
              </v-tab>
              <v-tab>
                <h6 class="text-subtitle-2 text-capitalize">Expired</h6>
              </v-tab>
            </v-tabs>
          </v-card-title>
          <v-divider class="mb-2"></v-divider>
          <v-card-text>
            <v-tabs-items v-model="subSubscriptionTab">
              <v-tab-item>
                <v-list
                  outlined
                  max-height="250px"
                  color="rounded-lg"
                  v-if="
                    subscriptionInfo &&
                    Object.keys(subscriptionInfo).length > 0 &&
                    subscriptionInfo.active
                  "
                >
                  <v-list-item
                    v-for="(value, key) in subscriptionInfo.active"
                    :key="key"
                  >
                    <v-list-item-icon>
                      <v-icon color="indigo"> mdi-domain </v-icon>
                    </v-list-item-icon>

                    <v-list-item-content>
                      <v-list-item-title class="text-capitalize" v-if="key">{{
                        key.replace(/_/g, " ")
                      }}</v-list-item-title>
                    </v-list-item-content>

                    <v-list-item-icon>
                      <v-chip small class="red white--text">
                        {{ value }}
                      </v-chip>
                    </v-list-item-icon>
                  </v-list-item>
                </v-list>
              </v-tab-item>
              <v-tab-item>
                <v-list
                  outlined
                  color="rounded-lg"
                  max-height="250px"
                  v-if="
                    subscriptionInfo &&
                    Object.keys(subscriptionInfo).length > 0 &&
                    subscriptionInfo.expired
                  "
                >
                  <v-list-item
                    v-for="(value, key) in subscriptionInfo.expired"
                    :key="key"
                  >
                    <v-list-item-icon>
                      <v-icon color="indigo"> mdi-domain </v-icon>
                    </v-list-item-icon>

                    <v-list-item-content>
                      <v-list-item-title class="text-capitalize" v-if="key">{{
                        key.replace(/_/g, " ")
                      }}</v-list-item-title>
                    </v-list-item-content>

                    <v-list-item-icon>
                      <v-chip small class="red white--text">
                        {{ value }}
                      </v-chip>
                    </v-list-item-icon>
                  </v-list-item>
                </v-list>
              </v-tab-item>
            </v-tabs-items>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col
        cols="12"
        md="6"
        lg="3"
        v-if="subscriptionChart && Object.keys(subscriptionChart).length > 0"
      >
        <span class="text-body-1 font-weight-bold">Subscription Summary</span>
        <v-card min-height="300px" flat class="h-100">
          <v-card-text
            v-if="
              subscriptionChart && Object.keys(subscriptionChart).length > 0
            "
          >
            <BarChart
              :options="chartOptions"
              :data="subscriptionChart"
              :height="270"
            />
          </v-card-text>
        </v-card>
      </v-col>
      <!-- <v-col
        cols="12"
        md="6"
        v-if="
          companyOnboardingData && Object.keys(companyOnboardingData).length > 0
        "
      >
        <span class="text-body-1 font-weight-bold pb-6 w-200">
          Company Onboarding Summary
        </span>
      </v-col> -->
      <!-- <v-col
        cols="12"
        md="6"
        v-if="
          supportTicketChartData &&
          Object.keys(supportTicketChartData).length > 0
        "
      >
        <span class="text-body-1 font-weight-bold pb-6 w-200">
          Support Ticket Summary
        </span>
      </v-col> -->
      <v-col
        cols="12"
        md="6"
        lg="3"
        v-if="
          companyOnboardingData && Object.keys(companyOnboardingData).length > 0
        "
      >
        <span class="text-body-1 font-weight-bold pb-6 w-200">
          Company Onboarding Summary
        </span>
        <v-card min-height="300px" flat class="h-100">
          <v-card-text
            v-if="
              companyOnboardingData &&
              Object.keys(companyOnboardingData).length > 0
            "
          >
            <RadarChart :data="companyOnboardingData" :height="270" />
          </v-card-text>
        </v-card>
      </v-col>
      <v-col
        cols="12"
        md="6"
        lg="3"
        v-if="
          supportTicketChartData &&
          Object.keys(supportTicketChartData).length > 0
        "
      >
        <span class="text-body-1 font-weight-bold pb-6 w-200">
          Support Ticket Summary
        </span>
        <v-card min-height="300px" flat class="h-100">
          <v-card-text
            v-if="
              supportTicketChartData &&
              Object.keys(supportTicketChartData).length > 0
            "
          >
            <LineChart
              :data="supportTicketChartData"
              :height="270"
              :options="chartOptions"
            />
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>
<script>
import {
  adminDashboardModule,
  companyModule,
  tripModule,
} from "@/utils/moduleMapping";
import RadarChart from "@/components/ComponentLibrary/Charts/RadarChart.vue";
import { getUserDetailsLocalStorage } from "@/utils/functions";

export default {
  components: { RadarChart },
  name: "adminIndex",
  data() {
    return {
      getUserDetailsLocalStorage,
      adminDashboardModule,
      companyModule,
      tripModule,
      subSubscriptionTab: 0,
      dashboardStatistics: [],
      subscriptionInfo: null,
      companyOnboardingData: null,
      supportTicketChartData: null,
      subscriptionChart: null,

      chartOptions: {
        responsive: true,
        scales: {
          y: {
            min: 0,
            max: 100,
            ticks: {
              // forces step size to be 50 units
              stepSize: 50,
            },
          },
        },
      },
    };
  },
  methods: {
    getWidgetData() {
      this.$api.systemAdminDashboard
        .getSystemAdminStatistics()
        .then((res) => {
          console.log(res);
          this.dashboardStatistics = res.data;
          this.subscriptionInfo = res.data.subscription_info;
          delete this.dashboardStatistics.subscription_info;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getSubscriptionChartData() {
      this.$api.systemAdminDashboard
        .getSubscriptionChartData()
        .then((res) => {
          this.subscriptionChart = res.data.subscription;
          console.log(this.subscriptionChart);
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getCompanyOnboardingChartData() {
      this.$api.systemAdminDashboard
        .getCompanyOnboardingChartData()
        .then((res) => {
          this.companyOnboardingData = res.data.on_boarding;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getSupportTicketChartChartData() {
      this.$api.systemAdminDashboard
        .getSupportTicketChartChartData()
        .then((res) => {
          this.supportTicketChartData = res.data.support_ticket;
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
  mounted() {
    let userObj = getUserDetailsLocalStorage();
    if (userObj.role == "system_admin" || userObj.role == "account_manager") {
      this.getWidgetData();
      this.getSubscriptionChartData();
      this.getCompanyOnboardingChartData();
      this.getSupportTicketChartChartData();
    }
  },
};
</script>
